import dayjs from "dayjs";
import { navigate } from "raviger";
import { useTranslation } from "react-i18next";

import CareIcon from "@/CAREUI/icons/CareIcon";

import { Button } from "@/components/ui/button";

import PatientAuthMethods from "@/components/Auth/PatientAuthMethods";

import { useAuthContext } from "@/hooks/useAuthUser";

import { goBack } from "@/Utils/utils";

export default function PatientLogin({
  facilityId,
  staffId,
}: {
  facilityId: string;
  staffId: string;
  page: string;
}) {
  const { t } = useTranslation();
  const { patientToken: tokenData } = useAuthContext();

  const redirectUrl = `/facility/${facilityId}/appointments/${staffId}/book-appointment`;

  if (
    tokenData &&
    Object.keys(tokenData).length > 0 &&
    dayjs(tokenData.createdAt).isAfter(dayjs().subtract(14, "minutes"))
  ) {
    navigate(redirectUrl);
  }

  return (
    <div className="container max-w-3xl mx-auto p-10">
      <Button
        variant="outline"
        className="border border-secondary-400"
        onClick={() => goBack(`/facility/${facilityId}`)}
      >
        <CareIcon icon="l-arrow-left" className="size-4 mr-1" />
        <span className="text-sm underline">{t("back")}</span>
      </Button>
      <div className="mt-4">
        <h1 className="text-xl font-semibold">{t("patient_login")}</h1>
        <PatientAuthMethods redirectUrl={redirectUrl} />
      </div>
    </div>
  );
}
